/**
  * Converte o retorno de erro do backend para um formato padronizado.
  *
  * A API pode retornar três tipos de erros dentro de "message":
  *   - metadataErrors
  *   - headerErrors
  *   - bodyErrors
  *
  * Cada grupo pode vir sozinho ou combinado com os demais.
  * A função unifica todos eles em um único array, garantindo que:
  *   • 'linha' e 'coluna' sejam preenchidos quando existirem
  *   • caso não existam, sejam definidos como null
  *   • 'mensagem' sempre seja retornada
  *
  * Se o JSON de message for inválido ou diferente do esperado,
  * a função retorna um array contendo apenas 1 erro genérico.
 */
export function parseUploadErrors(errorMessage) {
  let parsed;

  try {
    parsed = JSON.parse(errorMessage);
  } catch {
    return [{ linha: null, coluna: null, mensagem: errorMessage }];
  }

  const groups = [
    parsed.metadataErrors || [],
    parsed.headerErrors || [],
    parsed.bodyErrors || []
  ];

  return groups
    .flat()
    .map(err => ({
      linha:   err.line   ?? null,
      coluna:  err.column ?? null,
      mensagem: err.message
    }));
}